import {texture} from "p3";
import { NineSlicePlane } from "pixi.js-legacy";
import GameScene from "../../../scenes/GameScene";
import {iswebfont, locale, resizeLabelToFitText} from "../../../utils";

export default class MinigameTracker extends PIXI.Container {
    constructor() {
        super();

        this._frame = null;
        this._timer = null;

        this._nameLabel = null;
        this._descriptionLabel = null;

        this._timerRadius = 35;
        this._timerProgress = 0;
        this._timerProgressEase = 0;
        this._timerProgressSmooth = 100;

        this._rightContents = null;
        this._bar = null;

        this.init();
    }

    init() {
        this._frame = new PIXI.NineSlicePlane(texture("panel_progess_tracker"), 80, 20, 20, 20);//new PIXI.Sprite(texture("panel_progess_tracker"));
        this.addChild(this._frame);

        this._rightContents = new PIXI.Container();
        this._rightContents.x = 86;
        this._rightContents.y = 20;
        this.addChild(this._rightContents);

        if (!iswebfont()) {
            this._nameLabel = new PIXI.BitmapText("", {
                fontName: "Alghera Pro",
                fontSize: 26,
                align: "left",
                tint: 0x000000,
                maxWidth: 340
            });
        } else {
            this._nameLabel = new PIXI.Text("", {
                fontFamily: "FredFredBurger",
                fontSize: 26,
                align: "left",
                fill: 0x000000,
                wordWrap: true,
                wordWrapWidth: 340
            });
        }
        this._nameLabel.position.set(0, 0);//!iswebfont() ? 44 : 41);
        this._nameLabel.anchor.set(0, 0);
        this._rightContents.addChild(this._nameLabel);
        resizeLabelToFitText(this._nameLabel, 340);

        if (!iswebfont()) {
            this._descriptionLabel = new PIXI.BitmapText("", {
                fontName: "Alghera Pro",
                fontSize: 20,
                align: "left",
                tint: 0x732612,
                maxWidth: 340
            });
        } else {
            this._descriptionLabel = new PIXI.Text("", {
                fontFamily: "FredFredBurger",
                fontSize: 20,
                align: "left",
                fill: 0x732612,
                wordWrap: true,
                wordWrapWidth: 340
            });
        }
        this._descriptionLabel.position.set(0, 0);//!iswebfont() ? 50 : 46);
        this._descriptionLabel.anchor.set(0, 0);
        this._rightContents.addChild(this._descriptionLabel);
        //resizeLabelToFitText(this._descriptionLabel, 340);

        this._bar = new PIXI.Container();
        this._bar.x = this._descriptionLabel.x;
        this._bar.y = this._descriptionLabel.y + (!iswebfont() ? this._descriptionLabel.textHeight : this._descriptionLabel.height) + 16;
        this._rightContents.addChild(this._bar);

        const margins = {left:6, right:5, top:4, bottom:4};
        this._bar.margins = margins;

        const barFrame = new PIXI.Sprite(texture('progress_bar_frame'));
        this._bar.frame = barFrame;
        barFrame.scale.set(0.6);
        
        const barFill = new PIXI.Sprite(PIXI.Texture.WHITE);
        barFill.tint = 0x4bb6b5;
        barFill.x = barFrame.x + margins.left;
        barFill.y = barFrame.y + margins.top;
        barFill.width = 0;//((barFrame.width - margins.left - margins.right) * 0.5);
        barFill.height = barFrame.height - margins.top - margins.bottom;
        this._bar.fill = barFill;
        this._bar.addChild(barFill);

        this._bar.addChild(barFrame);

        let progressLabel;
        if (!iswebfont()) {
            progressLabel = new PIXI.BitmapText("", {
                fontName: "Alghera Pro",
                fontSize: 26,
                align: "left",
                tint: 0x702311,
                maxWidth: 250
            });
        } else {
            progressLabel = new PIXI.Text("", {
                fontFamily: "FredFredBurger",
                fontSize: 26,
                align: "left",
                fill: 0x702311,
                wordWrap: true,
                wordWrapWidth: 250
            });
        }
        progressLabel.anchor.set(0, 0.5);
        progressLabel.x = barFrame.x + barFrame.width + 5;
        progressLabel.y = (barFrame.y + (barFrame.height/2)) + (!iswebfont() ? 0 : -4);
        this._bar.progressLabel = progressLabel;
        this._bar.addChild(progressLabel);

        this._bar.icon = new PIXI.Sprite();
        this._bar.icon.anchor.set(0.5);
        this._bar.icon.scale.set(0.75);
        this._bar.icon.y = barFrame.y + (barFrame.height/2);
        this._bar.addChild(this._bar.icon);

        this._timer = new PIXI.Sprite(texture("timer_brown"));
        this._timer.position.set(40, 43);
        this._timer.anchor.set(0.5);
        this.addChild(this._timer);

        /*
        this._timer.fill = new PIXI.Sprite(texture("timer_yellow"));
        this._timer.fill.anchor.set(0.5);
        this._timer.addChild(this._timer.fill);
        */

        this._timer.fill = new PIXI.Container();
        this._timer.addChild(this._timer.fill);
        this._timer.fill.segments = [];

        for( let i = 0; i < 30; i ++) {
            let spr = new PIXI.Sprite(texture('timer_yellow_segment'));
            spr.anchor.set(0.5);
            spr.rotation = i * (12 * PIXI.DEG_TO_RAD);
            this._timer.fill.addChild(spr);
            this._timer.fill.segments.push(spr);
        }

        if (!iswebfont()) {
            this._timer.label = new PIXI.BitmapText("99", {
                fontName: "Alghera Pro",
                fontSize: 30,
                align: "center",
                tint: 0x632718
            });
        } else {
            this._timer.label = new PIXI.Text("99", {
                fontFamily: "FredFredBurger",
                fontSize: 30,
                align: "center",
                fill: 0x632718
            });
        }
        this._timer.label.position.set(0, !iswebfont() ? 3 : -2);
        this._timer.label.anchor.set(0.5);
        this._timer.addChild(this._timer.label);

        /*
        this._timer.fill.mask = new PIXI.Graphics();
        this._timer.addChild(this._timer.fill.mask);
        */
    }

    update() {
        this._timerProgressEase += (this._timerProgress - this._timerProgressEase) * this._timerProgressSmooth * window.dt;

        /* Note: This method causes issues on some mobiles
        const startAngle = -Math.PI * 0.5;
        const endAngle = startAngle + Math.PI * 2 * this._timerProgressEase;

        this._timer.fill.mask.clear();
        this._timer.fill.mask.beginFill(0xFF0000);
        this._timer.fill.mask.moveTo(0, 0);
        this._timer.fill.mask.arc(0, 0, this._timerRadius, startAngle, endAngle, false);
        this._timer.fill.mask.lineTo(0, 0);
        this._timer.fill.mask.endFill();*/



        /* Note: this method works, but flickers on mobile (as does the previous one)
        this._timer.fill.mask.clear();
        this._timer.fill.mask.beginFill(0xFF0000);
    
        var degreeAmount = 360 / 60;
        var distance = this._timerRadius;
    
        for(var i = 60; i >= 0; i--){
            if(i < this._timerProgressEase * 60){
                var angle1 = (degreeAmount * i);
                var angle2 = (angle1 - degreeAmount);
    
                angle1 = angle1 * PIXI.DEG_TO_RAD;
                angle2 = angle2 * PIXI.DEG_TO_RAD;
    
                this._timer.fill.mask.moveTo(0, 0);
                this._timer.fill.mask.lineTo( -1 * (-Math.sin(angle1) * distance), -1 * (Math.cos(angle1) * distance) );
                this._timer.fill.mask.lineTo( -1 * (-Math.sin(angle2) * distance), -1 * (Math.cos(angle2) * distance) );
                this._timer.fill.mask.lineTo(0, 0);
            }
        }
        this._timer.fill.mask.endFill();
        */

        for( let i = this._timer.fill.segments.length-1; i >= 0; i--) {
            this._timer.fill.segments[i].visible = i / (this._timer.fill.segments.length - 1) > this._timerProgress;
        }
    }

    /**
     * @return {Promise}
     */
    animateIn() {
        return new Promise((resolve) => {
            this.scale.set(0);
            this.alpha = 1;

            GameScene.active.addTween(gsap.to(this.scale, 0.24, {
                x: 1,
                y: 1,
                ease: Back.easeOut,
                onStart: () => this.visible = true,
                onComplete: resolve
            }));
        });
    }

    /**
     * @return {Promise}
     */
    animateOut() {
        return new Promise((resolve) => {
            GameScene.active.addTween(gsap.to(this.scale, 0.24, {
                x: 0,
                y: 0,
                ease: Back.easeIn,
                onComplete: () => {
                    this.visible = true;
                    resolve();
                }
            }));
        });
    }

    /**
     * @param {string} text
     */
    setName(text) {
        this._nameLabel.text = locale(text);
        //resizeLabelToFitText(this._nameLabel, 340);
        this._descriptionLabel.y = this._nameLabel.height + 7;
        this._frame.height = this._rightContents.height + (this._frame.bottomHeight * (this._bar.visible ? 1.5 : 2));
        this._onTextUpdate();
    }

    /**
     * @param {string} text
     */
    setDescription(text) {
        this._descriptionLabel.text = locale(text);
        this._bar.y = this._descriptionLabel.y + (!iswebfont() ? this._descriptionLabel.textHeight : this._descriptionLabel.height) + 16;
        this._frame.height = this._rightContents.height + (this._frame.bottomHeight * (this._bar.visible ? 1.5 : 2));
        this._onTextUpdate();
    }

    _onTextUpdate() {
        this._frame.width = Math.max(this._frame.texture.width, this._frame.leftWidth + this._frame.rightWidth + Math.max(this._nameLabel.width, this._descriptionLabel.width));
        this.pivot.set(this._frame.width/2, this._frame.texture.height/2);
        //this.pivot.set(this._frame.texture.width * 0.5, this._frame.texture.height * 0.5);
    }

    /**
     * @param {number} time
     * @param {number} duration
     * @param {boolean} [animate=false]
     */
    setTime(time, duration, animate= false) {
        this._timerProgress = 1 - (time / duration);
        this._timer.label.text = Math.round(duration - time) + "";

        if (!animate) {
            this._timerProgressEase = this._timerProgress;
        }
    }

    /**
     * @param {number} icon
     * @param {number} maxScore
     * @param {boolean} [animate=false]
     */
    setBar(icon, maxScore) {
        if (!maxScore) {
            this._bar.visible = false;
            this._frame.height = this._rightContents.height + (this._frame.bottomHeight * 2);
        }
        this._bar.icon.texture = texture(icon);
        this._bar.progressLabel.text = "0/" + maxScore;
        this._bar.maxScore = maxScore;
    }

    /**
     * @param {number} score
     */
    updateProgress(score) {
        this._bar.progressLabel.text = Math.min(score, this._bar.maxScore) + "/" + this._bar.maxScore;
        this._bar.fill.width = ((this._bar.frame.width - this._bar.margins.left - this._bar.margins.right) * (Math.min(score, this._bar.maxScore) / this._bar.maxScore));
    }

    get frame() {
        return this._frame;
    }

}